module.exports = __webpack_public_path__ + "img/ic_notification_warmup.2e6e8314.svg";